module.exports = __webpack_public_path__ + "static/bg-agro-1fef27a00b3936224bd87531b47a9703.png";